import React from 'react';
var SectionTitle = function SectionTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "component-title section_title"
  }, children);
};
export default SectionTitle;